import { Box, CardBody, Card, Flex, Heading, Text } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { ClientTeamMembership } from '../../../types/clientTeamMembership'
import { AvatarBubbles } from '../AvatarBubbles/AvatarBubbles'
import { formatCustomerProfileType } from '../../../helpers/formatCustomerProfileType'

export const MSG = defineMessages({
  // Needs to be updated to work with Loan officers
  heading: {
    id: 'PreferredPartnerCard.heading',
    defaultMessage: 'Real Estate Agent'
  },
  license: {
    id: 'PreferredPartnerCard.license',
    defaultMessage: 'License #{license}'
  }
})

export const PreferredPartnerCard = ({
  partner,
  corporateProfile
}: {
  partner: ClientTeamMembership['customerProfile']
  corporateProfile: ClientTeamMembership['corporateProfile']
}) => {
  const intl = useIntl()

  return (
    <Card size='sm'>
      <CardBody>
        <Flex alignItems='center' justifyContent='space-between' mb='0'>
          <Box>
            <Heading
              as='h3'
              size='3xs'
              variant='eyebrow'
              color='neutral.700'
              fontWeight='semibold'
              mb='0'
              textAlign='left'
            >
              {formatCustomerProfileType(partner.type)}
            </Heading>
            <Text color='neutral.900' fontWeight='bold' mb='0'>
              {partner.firstName} {partner.lastName}
            </Text>
            <Text size='sm' fontWeight='semibold' mb='0'>
              {corporateProfile?.name}
            </Text>
            {partner.stateLicense && (
              <Text color='neutral.800' size='3xs' mb='0'>
                {intl.formatMessage(MSG.license, { license: partner.stateLicense })}
              </Text>
            )}
          </Box>
          {(partner.photoUri || corporateProfile?.avatarUri) && (
            <AvatarBubbles photoUri={partner.photoUri} companyLogo={corporateProfile?.avatarUri} />
          )}
        </Flex>
      </CardBody>
    </Card>
  )
}
